import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["placeholder"]

  connect() {
    // This is useful when image is already in browser cache and we're
    // visiting or refreshing the same page.
    // Note: In development you won't encounter the need to clear placeholder
    // on #connect, as images are send without cache headers
    // and always loaded afresh, so in that case only the #load event comes into play.
    if (this.element.complete) {
      this.removePlaceholder()
    }
  }

  removePlaceholder() {
    this.element.classList.remove(this.placeholderClass)
  }
}
